<template>
<div>
  <v-tabs
    light
    icons-and-text
    class="immoapp__navigation"
  >

    <v-tab :to="{ name: 'exposes' }"  v-if="apps.indexOf('exposes') > -1">
      Immobilien
      <v-icon>fal fa-home</v-icon>
    </v-tab>

    <v-tab :to="{ name: 'saved-searches' }"  v-if="apps.indexOf('saved-searches') > -1">
      Suchprofile
      <v-icon>fal fa-search</v-icon>
    </v-tab>

    <v-tab :to="{ name: 'contact' }" exact v-if="apps.indexOf('contact') > -1">
      Kontakt
      <v-icon>fal fa-envelope</v-icon>
    </v-tab>

    <v-spacer></v-spacer>

    <div class="immoapp__logout" @click="logout()">
      {{ $t("userLogout", { username: null }) }}
      <span class="fas fa-sign-out" title="Logout"></span>
    </div>

    <router-view></router-view>
  </v-tabs>

</div>
</template>

<script>
export default {
  name: "Navigation",

  props: ["frontpage"],

  computed: {
    apps() {
      return this.$store.state.auth.apps;
    }
  },

  mounted() {
    if (this.frontpage) {
      this.$router.push(this.apps[0]);
    }
  },

  methods: {
    logout() {
      this.$store.dispatch("auth/logout");
    }
  }
};
</script>
